export class UpdateOrganizationLogoUrl {
	public logoUrl: string;
}
